import { useContext } from "react";
import AuthContext from "../../../context/auth/AuthContext";
import { haveValue } from "../../../helper/common";
import useTranslator from "../../../hooks/useTranslator";
import PropertyRow from "./PropertyRow";

const PropertyTable = ({ property, onPropertyAward, tanentData, loadData }) => {
  const { _t } = useTranslator();
  const authContext = useContext(AuthContext);
  const { user } = authContext;

  return (
    <>
      <div className="upcoming-box ">
        <table className="upcoming-table landlord-table bigtable_set">
          <thead>
            <tr className="first-row">
              <th> {_t("property")} </th>
              {user?.isParentLL && (
                <th> {_t("agent/landlord", "Field in properties table")} </th>
              )}
              <th> {_t("municipality", "Field in properties table")} </th>
              <th> {_t("postCode", "Field in properties table")} </th>
              <th> {_t("linkedTo", "Field in properties table")} </th>
              <th> </th>
            </tr>
          </thead>

          <tbody>
            {haveValue(property)
              ? property.map((data) => (
                  <PropertyRow
                    data={data}
                    onPropertyAward={onPropertyAward}
                    tanentData={tanentData}
                    loadData={loadData}
                    user={user}
                  />
                ))
              : _t("noDetailsFound")}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PropertyTable;
